import { SET_ACTIVE_PAGE } from 'src/app/redux/redux-types';

export const setActivePage = (page: string) => {
  return {
    type: SET_ACTIVE_PAGE,
    payload: page,
  };
};
